import { EMPTY, Observable } from 'rxjs';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';

import { LoaderService } from 'src/app/components/loader/loader.service';
import { MESSAGES } from 'src/app/constants/messages.constants';
import { PUBLIC_ROUTE } from 'src/app/constants/routes.constants';
import { PopupService } from 'src/app/components/popup/services/popup.service';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/components/toast-notification/toast.service';
import { Token } from '../token/index'
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');


@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  constructor(
    private $loader: LoaderService,
    private $toast: ToastService,
    private $token: Token,
    private $router: Router
  ) { }
  // intercept all http requests
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // check internet connectivity
    if (!navigator.onLine) {
      this.$toast.error(MESSAGES.OFFLINE);
      this.$loader.hide();
      return EMPTY;
    }
    let headers: any;
    // this.$loader.show();
    const isApiUrl = req.url.charAt(0) === '~';
    const isFormData = req.body instanceof FormData;

    // Development mode headers - simplified for local development
    // Do NOT set Content-Type for FormData; browser must set multipart boundary
    headers = {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      platform: '3',
      timezone: '0',
      deviceid: 'web-browser-123',
      api_key: '1234'
    };
    if (this.$token && this.$token.hasValue) {
      headers['Authorization'] = `Bearer ${this.$token.value}`;
    }

    // Add optional Basic auth for local dev endpoints that challenge with WWW-Authenticate
    const urlString = isApiUrl ? `${environment.apiBaseUrl}${req.url.substr(1)}` : req.url;
    const isSignupEndpoint = urlString.includes('/common/signUpStep1') || urlString.includes('/common/signUpStep2');

    // Apply Basic Auth for signup endpoints in dev mode, regardless of Bearer token
    if (environment.currentEnv === 'dev' && environment['devBasicAuthEnabled'] && isSignupEndpoint) {
      const user = environment['devBasicAuthUser'] || '';
      const pass = environment['devBasicAuthPass'] || '';
      if (user && pass) {
        try {
          const basic = btoa(`${user}:${pass}`);
          headers['Authorization'] = `Basic ${basic}`;
        } catch (_) {
          // ignore encoding issues
        }
      }
    } else if (!this.$token.hasValue && environment.currentEnv === 'dev' && environment['devBasicAuthEnabled']) {
      // Apply Basic Auth for other endpoints only when no Bearer token exists
      const user = environment['devBasicAuthUser'] || '';
      const pass = environment['devBasicAuthPass'] || '';
      if (user && pass) {
        try {
          const basic = btoa(`${user}:${pass}`);
          headers['Authorization'] = `Basic ${basic}`;
        } catch (_) {
          // ignore encoding issues
        }
      }
    }
    if (req.url.indexOf('blob.core.windows') != -1) {

      headers = {};
    }

    return next.handle(!(isApiUrl) ? req : req.clone({
      setHeaders: headers,
      withCredentials: true,
      url: isApiUrl ? `${environment.apiBaseUrl}${req.url.substr(1)}` : req.url// add base
    })).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          if(event.status !==201){
            this.$loader.hide();
          }
        }
        // return throwError(error);
      }, event => {
        if (event instanceof HttpErrorResponse) {
          if (req.url.indexOf('blob.core.windows') == -1) {
            this.$loader.hide();
          }
          // this.$loader.hide();

          if (event.status === 401) {
            this.$token.reset();
            this.$router.navigateByUrl(PUBLIC_ROUTE.url);
            this.$toast.error(MESSAGES.ERROR.$401);
          } else if (event.status === 400 && localStorage.getItem('signupData')){
            // Do not redirect away from signup endpoints on validation errors
            if(!this.$token.hasValue && !isSignupEndpoint){
              this.$token.reset();
              this.$router.navigateByUrl(PUBLIC_ROUTE.url);
            }
          } else if (event.status === 400 && urlString.includes('/user/profile')){
            // Suppress toast for 400 errors on user profile endpoint
            // This is expected when fetching profiles for CometChat users that may not exist in the platform database
          }
           else if (event.status === 504) {
            // this.$toast.error(MESSAGES.ERROR.$504);
          } else if (event.status === 0) {
            this.$toast.error(MESSAGES.ERROR.$0);
          } else if (event.status !== 439) {
            this.$toast.error(event.error.message);

          }
        }
      })
    );
    // }

  }
}
